import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';

import { AlertService, UserService, AuthenticationService } from '@app/_services';

@Component({
    templateUrl: 'register.component.html',
    standalone: false
})
export class RegisterComponent implements OnInit
{
    registerForm: UntypedFormGroup;
    loading = false;
    submitted = false;

    constructor(
        private formBuilder: UntypedFormBuilder,
        private router: Router,
        private authenticationService: AuthenticationService,
        private userService: UserService,
        private alertService: AlertService
    )
    {
        // redirect to home if already logged in
        if (this.authenticationService.currentUserValue)
        {
            this.router.navigate(['/']);
        }
    }

    ngOnInit()
    {
        this.registerForm = this.formBuilder.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            username: ['', Validators.required],
            password: ['', [Validators.required, Validators.minLength(6)]]
        });
    }

    // convenience getter for easy access to form fields
    get f() { return this.registerForm.controls; }

    onSubmit()
    {
        this.submitted = true;

        // stop here if form is invalid
        if (this.registerForm.invalid)
        {
            return;
        }

        this.loading = true;
        this.userService.register(this.registerForm.value)
            .pipe(first())
            .subscribe(
                data =>
                {
                    this.alertService.success('Registration successful', true);
                    this.router.navigate(['/login']);
                },
                error =>
                {
                    this.alertService.error(error);
                    this.loading = false;
                });
    }
}
